<div class="container border border rounded-top d-none d-sm-block">
  <div class="row align-items-center">
    <h5 class="col-xl-3 col-4 m-0 py-1 pe-0 justify-content-center fw-bold text-primary text-center">
      {{ 'SALON-DETAILS.MULTIPLE-TREATMENTS-BASKET.SELECTED-TREATMENTS' | translate }}
    </h5>
    <div #containerOfTreatments
         class="col text-container py-1 me-5 px-0 overflow-hidden">
      <span #listOftreatments
            class="d-inline-block px-3">
        <span class="d-block">{{ listOfTreatmentsNames }}</span>
      </span>
      <div class="fader fader-left"></div>
      <div class="fader fader-right"></div>
    </div>
    <div class="col-xl-1 col-2 px-0">
      <button class="btn btn-primary btn-desktop notranslate w-100 py-3"
              type="button"
              (click)="bookTreatments(selectedTreatments)">
        {{ 'SALON-DETAILS.MULTIPLE-TREATMENTS-BASKET.NEXT' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="container border-top d-sm-none m-0">
  <div class="row align-items-center">
    <span class="d-inline-block col-9">
      <h5 class="fw-bold text-primary m-0">{{ numberOfTreatments }} {{ numberOfTreatments === 1 ?
        ('SALON-DETAILS.MULTIPLE-TREATMENTS-BASKET.TREATMENT' | translate ) :
        ( 'SALON-DETAILS.MULTIPLE-TREATMENTS-BASKET.TREATMENTS' | translate ) }}
      </h5>
    </span>
    <div class="col-3 px-0">
      <button class="btn btn-primary btn-mobile rounded-start-2 w-100 py-3"
              type="button"
              (click)="bookTreatments(selectedTreatments)">
        {{ 'SALON-DETAILS.MULTIPLE-TREATMENTS-BASKET.NEXT' | translate }}
      </button>
    </div>
  </div>
</div>
